import React, { Component, useState } from 'react';
import i18n from 'i18n-react';
import algoliasearch from 'algoliasearch';
import { InstantSearch, SearchBox, Index, Configure, useInstantSearch } from 'react-instantsearch-hooks-web';

import { SearchHits } from 'C4';

const PopUpSearch = ({ buttonPopup, handlePopup }) => {
  const searchClient = algoliasearch('TRCCWLN5MZ', 'f93ec996b6352f6be2f9f55b4678c013');
  const indexes = ['chapters', 'pages', 'sales_companion_items', 'links'];
  const [hitDetails, setHitDetails] = useState({});

  const handleHitDetails = (hit) => {
    setHitDetails(hit);
  };
  // commented code works but returns errors
  // const EmptyQueryBoundary = ({ children, fallback }) => {
  //   {
  //     /* error still happens even tho it works */
  //   }
  //   const { indexUiState } = useInstantSearch();
  //   if (!indexUiState.query) {
  //     return null;
  //   }
  //   return children;
  // };
  // const NoResultsBoundary = ({ children, fallback }) => {
  //   {
  //     /* error still happens even tho it works */
  //   }
  //   const { results } = useInstantSearch();
  //   if (!results.__isArtificial && results.nbHits === 0) {
  //     return (
  //       <>
  //         {fallback}
  //         <div hidden>{children}</div>
  //       </>
  //     );
  //   }
  //   return children;
  // };
  // const NoResults = () => {
  //   return (
  //     <div className="noResultsCon">
  //       <p>{i18n.translate('general.noResults')}</p>
  //     </div>
  //   );
  // };

  const Hits = indexes.map((hitTypes) => (
    <div className="hitsColumn" key={hitTypes}>
      <div className="hitColumnTitle">
        <p>{hitTypes.replaceAll('_', ' ')}</p>
      </div>
      <Index indexName={hitTypes} attributesForFaceting="filterOnly(category)">
        <SearchHits className="searchRows" dataIndex={hitTypes} onHitDetails={handleHitDetails} />
      </Index>
    </div>
  ));

  const hitDetail = (hitDetails) => (
    <div>
      {hitDetails ? (
        <div>
          <img src={hitDetails.image}></img>
          <h1>{hitDetails.title}</h1>
          <p>{hitDetails.summary}</p>
        </div>
      ) : null}
    </div>
  );

  return buttonPopup ? (
    <div className="popupCon">
      {/* when clicked on the outside handlePopup should be called */}
      <div className="popup">
        <div className="innerPopup">
          <InstantSearch className="instandSearch" searchClient={searchClient} indexName="links">
            <header>
              <Configure filters={'app_id = 787'} />
              {/* left of input search icon needs to be added */}
              <div className="searchBar">
                {/* doesn't work after redirection + redirection close popup */}
                <SearchBox placeholder={i18n.translate('general.searchBarPlaceholder')}></SearchBox>
              </div>
              {/* rename that */}
              <div className="greyLine" />
              <button onClick={handlePopup}>close</button>
            </header>
            {/* <EmptyQueryBoundary fallback={null}> */}
            <div className="resultsCon">
              <div className="results">
                {/* <NoResultsBoundary fallback={<NoResults />}> */}
                {Hits}
                {/* </NoResultsBoundary> */}
              </div>
              <div className="resultDetails">{hitDetail(hitDetails)}</div>
            </div>
            {/* </EmptyQueryBoundary> */}
          </InstantSearch>
        </div>
      </div>
    </div>
  ) : (
    ''
  );
};

export default PopUpSearch;
